import { render } from "./businessInfoUpdate.vue?vue&type=template&id=32cdac6e&scoped=true"
import script from "./businessInfoUpdate.vue?vue&type=script&lang=js"
export * from "./businessInfoUpdate.vue?vue&type=script&lang=js"

import "./businessInfoUpdate.vue?vue&type=style&index=0&id=32cdac6e&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cdac6e"]])

export default __exports__